<template>
  <b-modal size="xl" @ok="emitSelections" title="Buscar Contato" ok-only id="search-contact">
    <template #default>
      <div class="pb-1">
        <label class="font-bold mb-1"> Buscar em </label>
        <div class="flex gap-5 pl-2">
          <b-form-radio v-model="displayMode" value="contact">Contatos</b-form-radio>
          <b-form-radio v-model="displayMode" value="list">Listas</b-form-radio>
        </div>
      </div>
      <div class="pb-1">
        <label class="font-bold mb-1"> Contatos Selecionados <span>({{selectedContacts.length}})</span></label>
        <div class="overflow-y-auto rounded bg-grey-light bg-opacity-25 p-1" style="max-height: 10rem;">
          <table class="pl-2">
            <tr v-if="selectedContacts.length == 0">
              Nenhum contato foi selecionado ainda
            </tr>
            <tr v-for="contact, i in selectedContacts" :key="i">
              <td style="min-width: 10rem;">{{contact.name}}</td>
              <td class="font-semibold">{{contact.email}}</td>
            </tr>
          </table>
        </div>
      </div>
      <Grid
        hide_actions
        ref="list_grid"
        v-show="displayList"
        @changedSelection="updateSelectedContacts"
        :select-hook="completeModel"
        multiple-select
        :service="listService"
      >
        <template #actions>
        </template>
      </Grid>
      <Grid
        hide_actions
        ref="contact_grid"
        v-show="displayContact"
        @changedSelection="updateSelectedContacts"
        :select-hook="completeModel"
        multiple-select
        :service="contactService"
      >
        <template #actions>
        </template>
      </Grid>
    </template>
    <template #modal-ok>
      Adicionar
    </template>
  </b-modal>
</template>

<script>
import {
  BFormRadio,
} from 'bootstrap-vue'
import ContactListService from '@/services/api/ContactListService'
import ContactService from '@/services/api/ContactService'

export default {
  components: {
    BFormRadio
  },

  data: () => ({
    contactService: null,
    listService: null,
    selectedContacts: [],
    displayMode: 'list'
  }),

  watch: {
    displayMode(mode) {
      this.selectedContacts = []
      this.$refs.contact_grid.clearSelection()
      this.$refs.list_grid.clearSelection()
    }
  },

  methods: {
    completeModel(ids, gridVm) {
      let contacts = []
      const repository = gridVm.model.data

      ids.forEach((id) => {
        const model = repository.find(m => m.id == id)
        if (model && 'contacts_list' in model) {
          contacts = contacts.concat(model.contacts_list)
        }

        if (model && 'email' in model) {
          contacts = contacts.concat(model)
        }
      })

      return this._.uniqBy(contacts, 'email')
    },
    updateSelectedContacts(contacts) {
      this.selectedContacts = contacts
    },
    emitSelections() {
      this.$emit('selected', [...this.selectedContacts])
      this.$bvModal.hide('search-contact')
      //this.updateSelectedContacts = []
    }
  },

  computed: {
    displayList() {
      return this.displayMode === 'list'
    },
    displayContact() {
      return this.displayMode === 'contact'
    }
  },

  beforeMount() {
    this.listService = ContactListService.build(this.$vs)
    this.contactService = ContactService.build(this.$vs)
  }
}
</script>

<style>

</style>
